import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/API/api.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  addAdressForm: FormGroup
  phones: any
  addresses: any
  user: any
  deliveryCost:any
  orderForm: FormGroup
  showError: boolean = false
  vendorID: any
  constructor(private api: ApiService,private formBuilder: FormBuilder,private router: Router) {
    this.addAdressForm = this.formBuilder.group({
      address:['',[Validators.required]], 
      city_id:[{value: 'Asyut', disabled: true},[Validators.required]], 
      building:['',[Validators.required]], 
      floor:['',[Validators.required]], 
      flat:['',[Validators.required]], 
      special_mark:['',[Validators.required]]
    })

    this.orderForm = this.formBuilder.group({
      vendor:[,[Validators.required]],
      products:[,[Validators.required]],
      address:[,[Validators.required]],
      deliveryPhone:['',[Validators.required]],
      payMethod:["cash",[Validators.required]],
      deliveryMethod:[localStorage.getItem('deliveryMethod'),[Validators.required]],
      deliveryNote:[''],
      totalCost:[,[Validators.required]],
    })
  }

  ngOnInit(): void {
    const userData = localStorage.getItem('userData')
    if(userData){
      this.user = JSON.parse(userData)
    }
    const token = localStorage.getItem('userToken')
    if(!token){
      this.showError = true
      setTimeout(() => {
        history.back();
      }, 4000);
    }
    this.vendorID = localStorage.getItem('VendorID')
    if(this.vendorID){
      this.selectedVendor()
    }
    // console.log(this.user)
    this.getAllAddress()
    this.loadCart()

    const deliveryMethod = localStorage.getItem('deliveryMethod')
    if(deliveryMethod == 'delivery'){
      const delCost = localStorage.getItem('deliveryCost')
      this.deliveryCost = parseInt(delCost)
    }else if(deliveryMethod == 'pickUp'){
      this.deliveryCost = 0
    }
  }

  addressesCounter: number = 0
  getAllAddress(){
    this.api.getAddresses().subscribe({
      next: (response) => {
        this.addresses = response.data.myAddresses;
        this.addressesCounter = this.addresses.length
        this.phones = response.data.myPhone;
        console.log(this.phones)
        this.orderForm.patchValue({
          deliveryPhone: this.phones.phone || this.phones.sec_phone
        })
        if(this.addressesCounter == 1){
          this.setMainAddress(this.addresses[0].id)
        }
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  get f2(){
    return this.addAdressForm.controls;
  }

  goBack(){
    history.back()
  }

  formatAddress(address: any): string {
    if (!address) return '';
    this.orderForm.patchValue({
      address: `${address.address}, ${address.building ? 'عمارة: ' + address.building + ', ' : ''}${address.floor ? 'دور: ' + address.floor + ', ' : ''}${address.flat ? 'شقة: ' + address.flat : ''}`
    })
    // Customize this based on your address structure
    return `${address.address}, ${address.building ? 'عمارة: ' + address.building + ', ' : ''}${address.floor ? 'دور: ' + address.floor + ', ' : ''}${address.flat ? 'شقة: ' + address.flat : ''}`;
  }

  setMainAddress(addressId: number): void {
    this.api.setMainAddress(addressId).subscribe({
      next: (response) => {
        // Update the addresses to reflect the new main address
        this.addresses = this.addresses.map((addr: any) => ({
          ...addr,
          isMain: addr.id === addressId
        }));
        // console.log(this.addresses)
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  cart: any
  cartData: any
  cartTotalPrice: number = 0
  loadCart() {
    this.api.getMyCart().subscribe({
      next: (response) => {
        this.cart = response.data;
        // console.log(this.cart)
        this.updateCartData();
        this.calculateTotalPrice();
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }
  updateCartData() {
    this.cartData = {
      products: this.cart.map(item => ({
        // product_id: item.id,
        // type: item.selectedTypeId,
        quantity: item.quantity,
        name: item.name,
        price: this.getTypePrice(item.types,item.selectedTypeId),
        type: this.getTypeName(item.types, item.selectedTypeId)
      }))
    };
    this.orderForm.patchValue({
      products: this.cartData.products
    })
    // console.log(this.cartData.products);
  }
  calculateTotalPrice() {
    this.cartTotalPrice = this.cart.reduce((total: number, item: any) => {
      return total + this.calculateSubtotal(item);
    }, 0);
  }
  getTypePrice(types: any[], selectedTypeId: number): number {
    const type = types.find(t => t.id === selectedTypeId);
    return type ? type.price : 0;
  }
  calculateSubtotal(item: any): number {
    const price = this.getTypePrice(item.types, item.selectedTypeId);
    let subtotal = price * item.quantity;
    if (item.offer && item.offer.type === 'discount') {
      subtotal = subtotal * (1 - (item.offer.value / 100));
    }
    return subtotal;
  }
  getTypeName(types: any[], selectedTypeId: number): string {
    const type = types.find(t => t.id === selectedTypeId);
    return type ? type.name : '';
  }

  addAddress(){
    if(this.addAdressForm.valid){
      const formData = new FormData
      formData.append('city_id','2')
      formData.append('address',this.addAdressForm.value.address)
      formData.append('building',this.addAdressForm.value.building)
      formData.append('floor',this.addAdressForm.value.floor)
      formData.append('flat',this.addAdressForm.value.flat)
      formData.append('special_mark',this.addAdressForm.value.special_mark)
      console.log(formData)
      this.api.addAddress(formData).subscribe({
        next: (response) => {
          console.log(response)
          this.getAllAddress()
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  showSuccess:boolean=false
  successMsg=''
  deleteAddress(id){
    if(id){
      this.api.deleteAddress(id).subscribe({
        next: (response) => {
          console.log(response)
          this.showSuccess = true
          this.successMsg = 'تم حذف العنوان بنجاح'
          setTimeout(() => {
            this.showSuccess = false
            this.successMsg = ''
          }, 3000);
          this.getAllAddress()
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  vendorData: any
  serviceCost: number = 0
  selectedVendor(){
    if(this.vendorID){
      this.api.selectedVendor(this.vendorID,1).subscribe({
        next: (response) => {
          console.log(response.data)
          const { id, name, avatar } = response.data.selectedVendor;
          this.vendorData = { id, name, avatar };
          this.orderForm.patchValue({
            vendor: this.vendorData
          })
          this.serviceCost = parseInt(response.data.selectedVendor.serviceCost)
          const deliveryMethod = localStorage.getItem('deliveryMethod')
          if(deliveryMethod == 'delivery'){
            const delCost = localStorage.getItem('deliveryCost')
            this.deliveryCost = parseInt(response.data.selectedVendor.deliveryCost)
          }else if(deliveryMethod == 'pickUp'){
            this.deliveryCost = 0
          }
          // console.log(this.serviceCost)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  confirmOrder(){
    this.orderForm.patchValue({
      totalCost: this.cartTotalPrice + this.deliveryCost
    })
    console.log(this.orderForm.value)
    if(this.orderForm.valid){
      this.api.confirmOrder(this.orderForm.value).subscribe({
        next: (response) => {
          console.log(response)
          this.showSuccess = true
          this.successMsg = 'لقد تم تأكيد طلبك'
          console.log(this.successMsg)
          setTimeout(() => {
            this.router.navigate(['/orders']);
            this.showSuccess = false
            this.successMsg = ''
          }, 1000);
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  showAddressForm: boolean = false
  toggleAddressForm(){
    this.showAddressForm = !this.showAddressForm
    if(this.showAddressForm){
      $('.plusMinus').addClass('fa-minus-circle')
      $('.plusMinus').removeClass('fa-plus-circle')
    }else{
      $('.plusMinus').addClass('fa-plus-circle')
      $('.plusMinus').removeClass('fa-minus-circle')
    }
  }
}
